// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"630516d8","453":"8650a676","455":"754f1d01","977":"3abd321d"}[chunkId] + ".chunk.js";
};